
import { NewDropoffContact, NewDropoffCreator, NewDropoffInfos, NewDropoffLocation } from '../../domain/models/NewDropoff'
import * as Regex from '../regex'

export interface CreateDropoffFormErrors {
    creator?: CreateDropoffCreatorErrors
    infos?: CreateDropoffInfosErrors
    contact?: CreateDropoffContactErrors
    location?: CreateDropoffLocationErrors
}

export interface CreateDropoffCreatorErrors {
    email?: string
}

export interface CreateDropoffInfosErrors {
    name?: string
    facility?: string
    wasteCategories?: string
}

export interface CreateDropoffContactErrors {
    phone?: string
    website?: string
}

export interface CreateDropoffLocationErrors {
    address?: string
}

export function validateDropoffCreatorForm(form: NewDropoffCreator | undefined): CreateDropoffCreatorErrors | undefined {
    if (!form || !form.email || !Regex.EMAIL.test(form.email)) {
        return {
            email: 'SubmitDropoff.creator.email.error'
        }
    }
    return
}

export function validateDropoffInfosForm(form: NewDropoffInfos | undefined): CreateDropoffInfosErrors | undefined {
    const hasNameError = !form?.name  || form.name.length === 0
    const hasCategoriesError = !form?.wasteCategories || form.wasteCategories.length === 0
    const hasFacilityError = !form?.facility
    if (hasNameError || hasCategoriesError || hasFacilityError) {
        return {
            name: hasNameError ? 'SubmitDropoff.infos.name.error' : undefined,
            wasteCategories: hasCategoriesError ? 'SubmitDropoff.infos.wastes.error' : undefined,
            facility: hasFacilityError ? 'SubmitDropoff.infos.facility.error' : undefined
        }
    }
    return
}

export function validateDropoffContactForm(form: NewDropoffContact | undefined): CreateDropoffContactErrors | undefined {
    // No field validation for now, as opening hours selection validation is made inside its component.
    // Phone and website strings are not validated for now.
    return
}

export function validateDropoffLocationForm(form: NewDropoffLocation | undefined): CreateDropoffLocationErrors | undefined {
    const hasaddressError = !form || !form.formattedAddress 

    if (hasaddressError) {
        return {
            address: 'SubmitDropoff.location.address.error'
        }
    }

    const hasLineError = !form.line

    if(hasLineError) {
        return {
            address: 'SubmitDropoff.location.address.lineError'
        }
    }

    return
}
